import { render, staticRenderFns } from "./TourOverlay.vue?vue&type=template&id=051fe0ee&scoped=true"
import script from "./TourOverlay.vue?vue&type=script&lang=js"
export * from "./TourOverlay.vue?vue&type=script&lang=js"
import style0 from "./TourOverlay.vue?vue&type=style&index=0&id=051fe0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051fe0ee",
  null
  
)

export default component.exports